const defaultTheme = {
  primaryColor: '#183459',
  secondaryColor: '#ebebeb',
  highlightColor: '#96c11f',
  primaryFontColor: '#494949',
  secondaryFontColor: '#ffffff',
  backgroundColor: '#ffffff',
  cardColor: '#ffffff',
  disabledBackgroundColor: '#DBDBDB',
  disabledFontColor: '#979797',
  borderColor: '#979797',
  errorColor: '#ea4949',

  successColor: "#72c383",
  failureColor: "#e64947",

  buttonBorderRadius: '10',
  fontFamily: '"Open Sans", Helvetica, Arial, "Lucida Grande", sans-serif',

  tablet: '(max-width: 903px)',
  aboveTablet: '(min-width: 904px)',
  mobile: '(max-width: 767px)',
  aboveMobile: '(min-width: 768px)',
};

export default defaultTheme;
